<div class="jira_integration">
    <div class="jira_integration_top">
        <div class="top_left">
            <div class="top_left_logo">
                <img src="../../../assets/images/peganewlogo.png">
            </div>
            <div class="top_left_heading">
                Setting / Integration's
                <p>Manage Integration's</p>
            </div>

        </div>
        <div class="top_right">
            <div class="top_right_logo">
                <a (click)="navigatePreviousUrl()">
                    <span class="close-icon" matTooltip="close" uk-icon="close"></span>
                </a>
            </div>
            <div class="top_right_content">
                <div class="top_right_heading">
                    <span class="material-symbols-outlined">
                        play_circle
                    </span>
                    Installation Guide
                </div>
                <span class="material-symbols-outlined">
                    more_horiz
                </span>
            </div>
        </div>
    </div>
    <div class="jira_integration_middle">
        <div class="middle_left">
            <img src="../../../assets/images/back2.jpg">
        </div>
        <div *ngIf="!isAgileStudioIntegrationExists" class="middle_right">
            <h3>Welcome to {{brand.brandName}} Integration's for Agile!</h3>
            <p>You have no integration yet.<br>
                Add an integration to get started.</p>
            <button (click)="openAgileStudioIntegrationPopUp()">Add Integrate</button>
        </div>
        <div *ngIf="isAgileStudioIntegrationExists" class="middle_right">
            <h3>Integration Successful!</h3>
            <p>Your {{brand.brandName}} integration is now <span>Active.</span> <br>
                You can now start using the features to streamline your workflow.
            </p>
        </div>
    </div>
    <div class="jira_integration_bottom">
        <button>
            Get Integration Support
        </button>
    </div>
    <div class="agile_Intgration_Popup" *ngIf="isAgileIntegrationPopupVisible">
        <div class="agile_Intgration_Popup_Container">
            <span class="material-symbols-outlined">
                close
            </span>
            <h3>Agile Integration</h3>
            <p>To integrate with Agile Studio, please provide your credentials.</p>
            <div class="agile_Intgration_Popup_Container_Inputs">
                <input [(ngModel)]="username" placeholder="username">
                <input [(ngModel)]="password" type="password" placeholder="password">
            </div>
            <div class="agile_Intgration_Popup_Buttons">
                <button (click)="integrateAgile()">Integrate</button>
                <button (click)="closeAgileIntegrationPopup()">Cancel</button>
            </div>
        </div>
    </div>